export default class Shared {
  static multiDateFormat(d: any, m: any, y: any) {
    const newDate = y + '-' + Shared.minTwoDigits(m) + '-' + Shared.minTwoDigits(d);
    return newDate;
  }
  static minTwoDigits(n: any) {
   let val;
    if (n.toString().length === 1) {
      val = '0' + n;
    } else {
      val = n;
    }
    return val;
  }
}
